import { render, staticRenderFns } from "./userRank.vue?vue&type=template&id=f11ffb80&"
import script from "./userRank.vue?vue&type=script&lang=js&"
export * from "./userRank.vue?vue&type=script&lang=js&"
import style0 from "./userRank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports